import { Check } from "lucide-react";
import { FaStar } from "react-icons/fa";
import ImageSvg from "../ui/image-svg";

export const SegurosSection = () => {
  const seguros = [
    {
      name: "Seguro Básico",
      list: [
        "Roubo",
        "Furto",
        "Acidentes de qualquer natureza",
        "Dentro e fora dos veículos transportadores",
        "Tranquilidade do início ao fim do trajeto",
      ],
    },
    {
      name: "Seguro Avançado",
      list: [
        "Tudo do seguro padrão, com ainda mais segurança",
        "Pequenas Avarias de transporte",
        "Recomendada para veículos em bom estado",
        "Recomendada para veículos operantes",
        "Ideal para quem busca o máximo de tranquilidade",
        "Válida apenas para veículos operantes e em bom estado de conservação.",
      ],
    },
  ];
  return (
    <section className=" py-10 md:py-24 lg:py-32 bg-n-bg-green">
      <div className="container">
        <div className="text-center md:mb-20 mb-12">
          <h2 className="mb-5 text-n-secondary text-3xl font-semibold md:mb-6 md:text-5xl">
            Seguro padrão ou premium: <br />
            <span className="text-n-beige">você escolhe</span> o que melhor lhe
            atende
          </h2>
        </div>

        <div className="grid md:grid-cols-2 md:gap-8 gap-4">
          <div className="flex flex-col border-2 border-n-beige rounded-2xl px-12 pb-12 pt-2 gap-4">
            <div className="flex mb-6 w-full items-center justify-center md:h-[250px] h-[150px]">
              <ImageSvg
                src="seguro-basico.svg"
                alt="Planos de seguro"
                className="h-full"
              />
            </div>
            <h3 className="md:text-4xl mb-4 font-semibold text-n-beige">
              Seguro Padrão
            </h3>
            <p className="text-n-text-light">
              Cobertura robusta já inclusa em todas operações:
            </p>

            <ul className="space-y-2.5 text-n-text-light">
              {seguros[0].list.map((item) => (
                <li className="flex items-center gap-4" key={item}>
                  <Check className="h-6 w-6 text-n-secondary" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-col border-2 border-n-beige rounded-2xl px-12 pb-12 pt-2 gap-4">
            <div className="flex mb-6 w-full items-center justify-center md:h-[250px] h-[150px]">
              <ImageSvg
                src="seguro-premium.svg"
                alt="Planos de seguro"
                className="h-full"
              />
            </div>
            <div className="flex gap-4 flex-row items-center mb-4">
              <h3 className="md:text-4xl font-semibold text-n-beige">
                Seguro Premium
              </h3>
              <FaStar className="h-8 w-8 text-n-yellow" />
            </div>

            <ul className="space-y-2.5 text-n-text-light">
              {seguros[1].list.map((item) => (
                <li className="flex items-center gap-4" key={item}>
                  <Check className="h-6 w-6 text-n-secondary" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
